"use strict";
exports.__esModule = true;
var ChartMeasureRow = /** @class */ (function () {
    function ChartMeasureRow(_a) {
        var columns = _a.columns, value = _a.value, breakdown = _a.breakdown;
        var _this = this;
        this.toJSON = function () { return ({
            columns: _this.columns,
            value: _this.value,
            breakdown: _this.breakdown
        }); };
        this.columns = columns;
        this.value = value;
        this.breakdown = breakdown;
    }
    ChartMeasureRow.fromJSON = function (json) {
        var _a = Object.assign({}, json), columns = _a.columns, value = _a.value, breakdown = _a.breakdown;
        if (columns && !Array.isArray(columns))
            throw new Error('.columns must be an array');
        if (typeof value !== 'string' && value !== undefined && value !== null)
            throw new Error('.value must be a string');
        if (!Array.isArray(breakdown) && breakdown !== undefined && breakdown !== null)
            throw new Error('.breakdown must be an array');
        return new ChartMeasureRow({
            columns: columns,
            value: value,
            breakdown: breakdown
        });
    };
    return ChartMeasureRow;
}());
exports["default"] = ChartMeasureRow;
